import { Box, styled, useMediaQuery, useTheme, Button } from "@mui/material";
import logo from "@/assets/sdcp-logo-white.png";
import { ReactNode } from "react";
import { useAuthStore } from "@/store/authStore.ts";
import Navigation from "@/components/Navigation";
import ProfileButton from "@/components/Header/ProfileButton.tsx";
import { useGlobalSizingToolStore } from "@/store/globalSizingToolStore";
import SystemSizingToolButton from "@/components/SystemSizingToolButton";

const BoxHeaderInner = styled(Box)(({ theme }) => ({
  padding: "32px 80px 26px 80px",
  display: "flex",
  gap: "40px",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down("lg")]: {
    padding: "28px 24px 24px 24px",
  },
}));

const Header = ({ bottomSection }: { bottomSection?: ReactNode }) => {
  const isAuth = useAuthStore((state) => state.isAuth);
  const theme = useTheme();
  const downMd = useMediaQuery(theme.breakpoints.down("md"));
  const openGlobalSizingTool = useGlobalSizingToolStore(
    (state) => state.openModal
  );

  return (
    <Box sx={{ backgroundColor: "#003257", position: "relative", overflow: "visible" }}>
      <BoxHeaderInner>
        <Box
          sx={{
            display: "flex",
            gap: downMd ? "16px" : "40px",
            alignItems: "center",
            overflowX: "auto",
            overflowY: "visible",
          }}
        >
          {downMd && isAuth && <Navigation />}
          <img style={{ height: "48px", ...(downMd && { height: "auto", width: "110px" }) }} src={logo} />
          {!downMd && isAuth && <Navigation />}
          {isAuth && (
            <SystemSizingToolButton
              onClick={() => openGlobalSizingTool(undefined, false, true)}
            />
          )}
        </Box>
        {isAuth && <ProfileButton />}
      </BoxHeaderInner>
      {bottomSection}
    </Box>
  );
};

export default Header;
